import React from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import {HeaderCell} from '../atoms/tableCells';

const styles = (theme) => ({
  table: {
    tableLayout: 'auto',
    width: 'max-content',
  },
  noWrapCell: {
    whiteSpace: 'nowrap',
    wordBreak: 'keep-all',
    padding: '6px 4px 6px 8px',
  },
  multiSelectedLabel: {
    marginLeft: theme.spacing(1),
    color: theme.palette.error.main,
  },
});

/**
 * 対象電柱一覧
 *
 * @param {Object} props
 * @param {Array} props.dntList 電柱リスト
 * @param {string} props.maxHeight 一覧の最大高さ(超過時は縦スクロール)
 * @param {BoxProps} props.rest BoxコンポーネントのProps
 * @return {JSX.Element}
 */
const TargetDntList = (props) => {
  const {
    dntList,
    maxHeight,
    classes,
    ...rest
  } = props;

  return (
    <Box {...rest}>
      <h6 className="modal-title">
        対象電柱一覧
        {dntList.length > 1 &&
          <span className={classes.multiSelectedLabel}>複数項目選択中</span>
        }
      </h6>
      <TableContainer component={Paper} style={{maxHeight}}>
        <Table size="small" stickyHeader className={classes.table}>
          <TableHead>
            <TableRow>
              <HeaderCell className={classes.noWrapCell}>線路名</HeaderCell>
              <HeaderCell className={classes.noWrapCell}>電柱番号</HeaderCell>
              <HeaderCell className={classes.noWrapCell}>電柱区分</HeaderCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {dntList.map((dnt, index) => (
              <TableRow key={dnt.dataItem.Id ?? index}>
                <TableCell className={classes.noWrapCell}>
                  {dnt.dataItem.Dsp_SenroName__c}
                </TableCell>
                <TableCell className={classes.noWrapCell}>
                  {dnt.dataItem.Dsp_DntNo__c}
                </TableCell>
                <TableCell className={classes.noWrapCell}>
                  {dnt.dataItem.DntCategory}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

TargetDntList.propTypes = {
  dntList: PropTypes.array.isRequired,
  maxHeight: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

TargetDntList.defaultProps = {
  // 画面の高さに追従させるため、ビューポート基準で指定
  maxHeight: '50vh',
};

export default withStyles(styles)(TargetDntList);
